const MainFooter = () => {
  // Combine major version and commit hash for the full version
  const version = `${import.meta.env.VITE_MAJOR_VERSION}.${import.meta.env.VITE_COMMIT_HASH}`;
  const nodeEnv = import.meta.env.MODE === 'development' ? 'sandbox' : 'production';
  // const buildTimestamp = import.meta.env.VITE_BUILD_TIMESTAMP || 'unknown';
  return (
    <footer className="footer">
      <p>{nodeEnv} {version}</p>
    </footer>
  );
};

export default MainFooter;